import { memo } from 'react';

import * as styles from './LearningResourceCardSkeleton.styles';

export const LearningResourceCardSkeletonBase = () => {
  return (
    <div css={styles.container}>
      <div css={styles.header}>
        <div css={styles.avatarGroup}>
          <div css={styles.avatarSkeleton} />
          <div css={styles.presenterSkeleton} />
        </div>

        <div css={styles.tagSkeleton} />
      </div>

      <div css={styles.pictureWrapper}>
        <div css={styles.pictureSkeleton} />
        <div css={styles.replayTagSkeleton} />
        <div css={styles.iconBadgeSkeleton} />
      </div>

      <div css={styles.content}>
        <div css={styles.titleSkeleton} />
        <div css={styles.titleSkeletonSecondary} />
      </div>

      <div css={styles.footer}>
        <div css={styles.viewsRow}>
          <div css={styles.viewsIconSkeleton} />
          <div css={styles.viewsTextSkeleton} />
        </div>

        <div css={styles.dateSkeleton} />
      </div>
    </div>
  );
};

LearningResourceCardSkeletonBase.displayName = 'LearningResourceCardSkeleton';

export const LearningResourceCardSkeleton = memo(LearningResourceCardSkeletonBase);
